import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=0aab5612&scoped=true&"
import script from "./Register.vue?vue&type=script&lang=js&"
export * from "./Register.vue?vue&type=script&lang=js&"
import style0 from "./Register.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Register.vue?vue&type=style&index=1&id=0aab5612&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aab5612",
  null
  
)

export default component.exports